export default "__VITE_ASSET__CM$CRt5F__"